import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { calculateSegments } from './utils/calculate-segments.function';
import { ChartData } from '../data/chart-data';
import moment from 'moment/moment';

interface Segment {
  strokeDasharray: string;
  strokeDasharrayOffset: number;
  color: string;
}

@Component({
    selector: 'soft-circular-gauge',
    imports: [CommonModule],
    templateUrl: './circular-gauge.component.html',
    styleUrl: './circular-gauge.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CircularGaugeComponent {
  data = input.required<ChartData[]>();
  segmentHovered = output<string>();

  total = computed(() =>
    this.data().reduce((acc, curr) => acc + moment.duration(curr.value).asHours(), 0)
  );

  readonly segments = computed<Segment[]>(() => {
    const total = this.total();
    const data = this.data();

    return calculateSegments(data, total);
  });
}
